/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import PinKeyboard from '../components/keyboard/PinKeyboard';
import {setOfflineError} from '../../common/app/actions';
import {apiPinLogin} from '../../common/login/actions';
import {showLoginByPassword} from '../../common/login/actions';

class PinLogin extends React.Component {

    static propTypes = {
        deviceId: React.PropTypes.number,
        showLoginByPassword: React.PropTypes.func,
        setOfflineError: React.PropTypes.func,
        apiPinLogin: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(pin) {
        const {apiPinLogin, setOfflineError, deviceId, showLoginByPassword} = this.props;

        apiPinLogin({pin, deviceId}).payload.promise
            .then(() => {

            })
            .catch((res) => {
                if (!res.status) {
                    setOfflineError('Server je momentálně nedostupný, zkuste to prosím za chvíli.');
                } else if (res.status === 403) {
                    showLoginByPassword();
                }
            });
    }

    render() {
        return (
            <PinKeyboard onSubmit={this.onFormSubmit} showButtonLoginByPassword={true}/>
        );
    }
}

export default connect(state => ({
    deviceId: state.device.get('id')
}), {setOfflineError, apiPinLogin, showLoginByPassword})(PinLogin);



// WEBPACK FOOTER //
// ./src/browser/login/PinLogin.js